import { Form } from "devextreme-react";
import { Label, SimpleItem } from "devextreme-react/form";
import { useSelector } from "react-redux";
import ClassifWorkSelectBox from "./ClassifWorkSelectBox";
import DescriptionHtmlEditor from "./DescriptionHtmlEditor";
import DetailedTaskDropDownBox from "./DetailedTaskDropDownBox";
import ProjectDropDownBox from "./ProjectDropDownBox";
import SubjectTextBox from "./SubjectTextBox";
import TaskDropDownBox from "./TaskDropDownBox";

import "../index.css";

export default function WorkRecordForm(props) {
  // const { workRecord } = props;
  // const { setPopupVisible } = props;

  const {
    descriptionRef,
    classifWorkSelectBoxRef,
    projectDropDownBoxRef,
    taskDropDownBoxRef,
    detailedTaskDropDownBoxRef,
    subjectTextBoxRef,
    // currentEmployeeNo,
    currentEmployee,
  } = props;

  // const workRecord = useSelector((state) => state.workRecord);

  const classifWork = useSelector((state) => state.workRecord.classifWork);

  return (
    <Form
      id="form-workRecord"
      // ref={workRecordRef}
      // formData={workRecord}
      labelMode="outside"
      showColonAfterLabel={false}
      labelLocation="top"
      // validationGroup="workRecordGroup"
      colCount={4}
      // colCountByScreen={{ sm: 2, md: 4 }}
      // screenByWidth={(width) => {
      //   return width < 720 ? "sm" : "md";
      // }}
    >
      <SimpleItem dataField={"classifWork"}>
        <Label text={"Classification of Work *"} />
        <ClassifWorkSelectBox
          classifWorkSelectBoxRef={classifWorkSelectBoxRef}
          // currentEmployeeNo={currentEmployeeNo}
          currentEmployee={currentEmployee}
        />
      </SimpleItem>
      {/* <EmptyItem colSpan={3} /> */}
      <SimpleItem dataField={"contrNo"} colSpan={3}>
        <Label text={"Project *"} />
        <ProjectDropDownBox
          projectDropDownBoxRef={projectDropDownBoxRef}
          // currentEmployeeNo={currentEmployeeNo}
          currentEmployee={currentEmployee}
        />
      </SimpleItem>
      <SimpleItem dataField={"codeNo"} colSpan={2}>
        <Label text={"Task *"} />
        <TaskDropDownBox
          taskDropDownBoxRef={taskDropDownBoxRef}
          // currentEmployeeNo={currentEmployeeNo}
          currentEmployee={currentEmployee}
        />
      </SimpleItem>
      <SimpleItem dataField={"detailedTask"} colSpan={2}>
        <Label text="Detailed Task *" />
        <DetailedTaskDropDownBox
          detailedTaskDropDownBoxRef={detailedTaskDropDownBoxRef}
          // currentEmployeeNo={currentEmployeeNo}
          currentEmployee={currentEmployee}
        />
      </SimpleItem>
      <SimpleItem
        dataField={"subject"}
        colSpan={4}
        // editorType="dxTextBox"
        // editorOptions={{ showClearButton: true }}
      >
        <Label text={"Subject *"} />
        <SubjectTextBox
          subjectTextBoxRef={subjectTextBoxRef}
          // currentEmployeeNo={currentEmployeeNo}
          currentEmployee={currentEmployee}
        />
      </SimpleItem>
      <SimpleItem dataField={"descr"} colSpan={4}>
        <Label text={"Description"} />
        <DescriptionHtmlEditor
          descriptionRef={descriptionRef}
          // currentEmployeeNo={currentEmployeeNo}
          currentEmployee={currentEmployee}
        />
      </SimpleItem>
    </Form>
  );
}
